import { RocheEndpoint } from '@repo/roche-xx-shared';
import { RocheUIStoryType } from '@rocheglobal/roche-ui';
import { fetchMainSearchResults } from '../cludo-queries';
export interface RocheSearchResultItem {
  title: string;
  formattedReleaseDate: string;
  publishedDate: string;
  url: string;
  teaserType?: RocheUIStoryType;
  variant: SearchCategory;
  description: string;
  image: string;
}
export enum SearchCategory {
  PAGES = 'pages',
  STORIES = 'stories',
  DOCUMENTS = 'documents',
}

type FetchSearchResultsProps = {
  searchQuery: string;
  page: number;
  categoryFilter: SearchCategory;
  pageSize?: number;
};
export const searchViewDefaultPageSize = 6;

/**
 * Fetches search results for the main search feature
 *
 * @param params - Search parameters including query, category filter, page, and page size
 * @returns Transformed search results in RocheEndpoint format
 */
export const fetchSearchResults = async ({
  searchQuery,
  categoryFilter,
  page,
  pageSize = searchViewDefaultPageSize,
}: FetchSearchResultsProps): Promise<RocheEndpoint<RocheSearchResultItem[]>> => {
  return fetchMainSearchResults({
    searchQuery,
    categoryFilter,
    page,
    pageSize,
  }) as Promise<RocheEndpoint<RocheSearchResultItem[]>>;
};
